require('./travelPlusPurchase.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText } = require('core/i18n').i18n;

// @commons
const { OKMessage } = require('commonsComponents/OKMessage');

// @components
const TextToggle = require('components/commons/textToggle/textToggle');

// @constants
const bannerTravelPlusImage = require('assets/images/banner-travel-plus.jpg');

class TravelPlusPurchase extends React.Component {
    buildCategories() {
        const categories = [{
            description: 'travelPlusPurchase-travelPlusPurchase_freeComissionDescription',
            icon: 'icon-comercio-tiendas',
            title: 'travelPlusPurchase-travelPlusPurchase_freeComissionTitle',
        }, {
            icon: 'icon-diversificacion',
            title: 'travelPlusPurchase-travelPlusPurchase_freeConversionTitle',
            description: 'travelPlusPurchase-travelPlusPurchase_freeConversionDescription',
        }, {
            icon: 'icon-seguro-accidentes',
            title: 'travelPlusPurchase-travelPlusPurchase_freeSafeTitle',
            description: 'travelPlusPurchase-travelPlusPurchase_freeSafeDescription',
        }, {
            description: 'travelPlusPurchase-travelPlusPurchase_freeCashDescription',
            icon: 'icon-cajero',
            title: 'travelPlusPurchase-travelPlusPurchase_freeCashTitle',
        }];
        const categoryList = categories.map((category, index) => {
            return (
                <div key={index} className="travel-plus-purchase__category">
                    <div className="travel-plus-purchase__category-column">
                        <div className="travel-plus-purchase__category-column-icon">
                            <i className={category.icon} />
                        </div>
                    </div>
                    <div className="travel-plus-purchase__category-column">
                        <h5 className="travel-plus-purchase__category-column-title">
                            <FormattedText value={category.title} />
                        </h5>
                        <div className="travel-plus-purchase__category-column-description">
                            <FormattedText value={category.description} />
                        </div>
                    </div>
                </div>
            )
        });
        return (
            <div className="travel-plus-purchase__categories">
                {categoryList}
            </div>
        );
    }

    buildPriceBox() {
        const {
            isFree,
            getPoeKey,
        } = this.props;
        let content;

        if (isFree) {
            content = (
                <div className="travel-plus-purchase__price-box">
                    <span className="travel-plus-purchase__free-price">
                        {getPoeKey()}
                    </span>
                    <span className="travel-plus-purchase__per-month">
                        <FormattedText value="travelPlusPurchase-travelPlusPurchase_byMonth" />
                    </span>
                    <div className="travel-plus-purchase__price">
                        <FormattedText value="travelPlusPurchase-travelPlusPurchase_freePrice" />
                    </div>
                </div>
            );
        } else {
            content = (
                <div className="travel-plus-purchase__price-box">
                    <div className="travel-plus-purchase__date-text">
                        <FormattedText value="travelPlusPurchase-travelPlusPurchase_fromYouActiveTravel" />
                    </div>
                    <div className="travel-plus-purchase__price">{getPoeKey()}</div>
                    <div className="travel-plus-purchase__bold">
                        <FormattedText value="travelPlusPurchase-travelPlusPurchase_byMonth" />
                    </div>
                </div>
            );
        }

        return content;
    }

    buildMessagePriceBox() {
        const {
            hireTravelPlus,
            isFree,
            getPoeKey,
            toggleHireTravelPlus,
        } = this.props;
        let content;
        if (isFree) {
            content = (
                <div className="travel-plus-purchase__footer-text">
                    <OKMessage type="informative">
                        <span>
                            <FormattedText value="cardActivationR42-cardActivationR42_successService" />
                            <span className="travel-plus-purchase__bold">
                                <FormattedText value="cardActivationR42-cardActivationR42_successVipState" />
                            </span>
                        </span>
                    </OKMessage>
                </div>
            );
        } else {
            content = (
                <div className="travel-plus-purchase__footer-text ok-message--informative">
                     <div>
                        <FormattedText value="travelPlusPurchase-travelPlusPurchase_enjoyService" />
                        {getPoeKey()}
                        <FormattedText value="travelPlusPurchase-travelPlusPurchase_enjoyServiceFinal" />
                    </div>

                    <div className="travel-plus-purchase__travel-active">
                        <FormattedText
                            className="travel-plus-purchase__travel-active-text"
                            value="travelPlusPurchase-travelPlusPurchase_wishActiveTravel"
                        />
                        <div className="travel-plus-purchase__travel-active-switch">
                            <TextToggle
                                checked={hireTravelPlus}
                                textCheck="ON"
                                textUncheck="OFF"
                                onClick={toggleHireTravelPlus}
                            />
                        </div>
                        
                    </div>
 
                </div>
            );
        }

        return content;
    }

    render() {
        const categories = this.buildCategories();
        const priceBox = this.buildPriceBox();
        const payOrFreeMessage = this.buildMessagePriceBox();
        return (
            <div className="travel-plus-purchase">
                <img
                    className="travel-plus-purchase__header-image"
                    src={bannerTravelPlusImage}
                />
                <h4 className="travel-plus-purchase__title">
                    <FormattedText value="travelPlusPurchase-travelPlusPurchase_title" />
                </h4>
                <p className="travel-plus-purchase__description">
                    <FormattedText value="travelPlusPurchase-travelPlusPurchase_description" />
                </p>
                {categories}
                {priceBox}
                {payOrFreeMessage}
            </div>
        );
    }
}

TravelPlusPurchase.propTypes = {
    hireTravelPlus: PropTypes.bool,
    isFree: PropTypes.bool,
    price: PropTypes.object.isRequired,
    toggleHireTravelPlus: PropTypes.func,
};

TravelPlusPurchase.defaultProps = {
    hireTravelPlus: false,
    isFree: false,
    toggleHireTravelPlus: () => { },
};

module.exports = TravelPlusPurchase;
